import React from "react"

import { Box, Button, Chip, Grid, Link, Typography } from "@material-ui/core"

import { Notification } from "@/components"
import { BlueSettingsClockIcon } from "@/assets/icons"
import { FileCopyOutlined as FileCopyOutlinedIcon, PlayArrow } from "@material-ui/icons"
import { videoLinks } from "@/utils/link"

import videoThumbnail from "@/assets/images/videoThumbnails/thumbnail-video-pixel-letalk.jpg"
import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/SetupTrackableLinkAccordion/SetupTrackableLinkSteps/PixelLetalk/styles"
import copy from "copy-to-clipboard"

const PIXEL_LETALK = `
	<script>
		(function(){
			if(document.querySelector('script[src*="letalkUTMTrackerScript"]')) return;
			var s=document.createElement('script');
			s.src='https://cp.letalk.com.br/scripts/letalkUTMTrackerScript.js';
			s.async=true;
			s.onerror=function(){console.warn('Letalk UTM Tracker: Script não pôde ser carregado')};
			(document.head||document.body).appendChild(s);
		})();
	</script>
`

const PixelLetalk: React. FC = () => {
	const classes = useStyles()

	const copyScript = () => {
		copy(PIXEL_LETALK)
		Notification.success({ message: "Copiado com sucesso!" })
	}

	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<Chip
					icon={
						<BlueSettingsClockIcon className={classes.scriptLetalkChipIcon} />
					}
					label="Configure o pixel da Letalk em seu site e/ou landing page"
					size="small"
					className={classes.scriptLetalkChip}
				/>
			</Grid>

			<Grid item>
				<Grid container direction="row" spacing={2}>
					<Grid item xs={4}>
						<Link href={videoLinks.setupLetalkPixelTutorial} target="_blank" className={classes.videoContainer}>
							<Box className={classes.videoPlayer}>
								<PlayArrow className={classes.videoPlayerIcon} />
							</Box>
							<img src={videoThumbnail} alt="" className={classes.videoThumbnailImg} />
						</Link>
					</Grid>
					<Grid item xs={8}>
						<Typography variant="h5" className={classes.title}>
							Configure o pixel da Letalk dentro do seu site e ou landing page
						</Typography>

						<Typography variant="body2" className={classes.description}>
							Vai adicionar este link ao seu site ou landing page? Assista ao vídeo de instalação ao lado e siga o passo a passo para configurar o pixel da Letalk. Comece a rastrear com precisão os acessos gerados por essas páginas e tome decisões mais inteligentes com base nos dados hoje mesmo.
						</Typography>

						<Button
							className={classes.button}
							fullWidth
							variant="contained"
							color="primary"
							startIcon={
								<FileCopyOutlinedIcon
									className={classes.buttonIcon}
								/>
							}
							onClick={copyScript}
						>
							Copiar Pixel da Letalk
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default PixelLetalk
